export const WAY_TYPES = [
  { WAY_TYPE_ID: "104", WAY_TYPE_NAME: "ABBAYE" },
  { WAY_TYPE_ID: "59", WAY_TYPE_NAME: "AGGLOMERATION" },
  { WAY_TYPE_ID: "94", WAY_TYPE_NAME: "AIRE" },
  { WAY_TYPE_ID: "7", WAY_TYPE_NAME: "ALLEE" },
  { WAY_TYPE_ID: "66", WAY_TYPE_NAME: "ANCIEN CHEMIN" },
  { WAY_TYPE_ID: "73", WAY_TYPE_NAME: "ANCIENNE" },
  { WAY_TYPE_ID: "122", WAY_TYPE_NAME: "ANSE" },
  { WAY_TYPE_ID: "136", WAY_TYPE_NAME: "ARCADE" },
  { WAY_TYPE_ID: "130", WAY_TYPE_NAME: "AUTOROUTE" },
  { WAY_TYPE_ID: "8", WAY_TYPE_NAME: "AVENUE" },
  { WAY_TYPE_ID: "121", WAY_TYPE_NAME: "BARRIERE" },
  { WAY_TYPE_ID: "166", WAY_TYPE_NAME: "BAS CHEMIN" },
  { WAY_TYPE_ID: "131", WAY_TYPE_NAME: "BASTIDE" },
  { WAY_TYPE_ID: "168", WAY_TYPE_NAME: "BASTION" },
  { WAY_TYPE_ID: "153", WAY_TYPE_NAME: "BEGUINAGES" },
  { WAY_TYPE_ID: "141", WAY_TYPE_NAME: "BERGE" },
  { WAY_TYPE_ID: "32", WAY_TYPE_NAME: "BOIS" },
  { WAY_TYPE_ID: "100", WAY_TYPE_NAME: "BOUCLE" },
  { WAY_TYPE_ID: "11", WAY_TYPE_NAME: "BOULEVARD" },
  { WAY_TYPE_ID: "34", WAY_TYPE_NAME: "BOURG" },
  { WAY_TYPE_ID: "128", WAY_TYPE_NAME: "BUTTE" },
  { WAY_TYPE_ID: "139", WAY_TYPE_NAME: "CALE" },
  { WAY_TYPE_ID: "74", WAY_TYPE_NAME: "CAMP" },
  { WAY_TYPE_ID: "54", WAY_TYPE_NAME: "CAMPAGNE" },
  { WAY_TYPE_ID: "47", WAY_TYPE_NAME: "CAMPING" },
  { WAY_TYPE_ID: "132", WAY_TYPE_NAME: "CARRE" },
  { WAY_TYPE_ID: "146", WAY_TYPE_NAME: "CARREAU" },
  { WAY_TYPE_ID: "50", WAY_TYPE_NAME: "CARREFOUR" },
  { WAY_TYPE_ID: "82", WAY_TYPE_NAME: "CARRIERES" },
  { WAY_TYPE_ID: "114", WAY_TYPE_NAME: "CASTEL" },
  { WAY_TYPE_ID: "101", WAY_TYPE_NAME: "CAVEE" },
  { WAY_TYPE_ID: "52", WAY_TYPE_NAME: "CENTRE" },
  { WAY_TYPE_ID: "46", WAY_TYPE_NAME: "CENTRE COMMERCIAL" },
  { WAY_TYPE_ID: "87", WAY_TYPE_NAME: "CHALET" },
  { WAY_TYPE_ID: "108", WAY_TYPE_NAME: "CHAPELLE" },
  { WAY_TYPE_ID: "174", WAY_TYPE_NAME: "CHARMILLE" },
  { WAY_TYPE_ID: "23", WAY_TYPE_NAME: "CHATEAU" },
  { WAY_TYPE_ID: "67", WAY_TYPE_NAME: "CHAUSSEE" },
  { WAY_TYPE_ID: "177", WAY_TYPE_NAME: "CHEMIN" },
  { WAY_TYPE_ID: "147", WAY_TYPE_NAME: "CHEMIN VICINAL" },
  { WAY_TYPE_ID: "105", WAY_TYPE_NAME: "CHEMINEMENT" },
  { WAY_TYPE_ID: "22", WAY_TYPE_NAME: "CHEZ" },
  { WAY_TYPE_ID: "16", WAY_TYPE_NAME: "CITE" },
  { WAY_TYPE_ID: "155", WAY_TYPE_NAME: "CLOITRE" },
  { WAY_TYPE_ID: "25", WAY_TYPE_NAME: "CLOS" },
  { WAY_TYPE_ID: "77", WAY_TYPE_NAME: "COL" },
  { WAY_TYPE_ID: "126", WAY_TYPE_NAME: "COLLINE" },
  { WAY_TYPE_ID: "102", WAY_TYPE_NAME: "CONTOUR" },
  { WAY_TYPE_ID: "83", WAY_TYPE_NAME: "CORNICHE" },
  { WAY_TYPE_ID: "42", WAY_TYPE_NAME: "COTE" },
  { WAY_TYPE_ID: "125", WAY_TYPE_NAME: "COTTAGE" },
  { WAY_TYPE_ID: "27", WAY_TYPE_NAME: "COUR" },
  { WAY_TYPE_ID: "43", WAY_TYPE_NAME: "COURS" },
  { WAY_TYPE_ID: "173", WAY_TYPE_NAME: "DARSE" },
  { WAY_TYPE_ID: "149", WAY_TYPE_NAME: "DEGRES" },
  { WAY_TYPE_ID: "96", WAY_TYPE_NAME: "DESCENTE" },
  { WAY_TYPE_ID: "110", WAY_TYPE_NAME: "DIGUE" },
  { WAY_TYPE_ID: "24", WAY_TYPE_NAME: "DOMAINE" },
  { WAY_TYPE_ID: "55", WAY_TYPE_NAME: "ECLUSE" },
  { WAY_TYPE_ID: "123", WAY_TYPE_NAME: "EGLISE" },
  { WAY_TYPE_ID: "33", WAY_TYPE_NAME: "ENCEINTE" },
  { WAY_TYPE_ID: "175", WAY_TYPE_NAME: "ENCLAVE" },
  { WAY_TYPE_ID: "88", WAY_TYPE_NAME: "ENCLOS" },
  { WAY_TYPE_ID: "80", WAY_TYPE_NAME: "ESCALIER" },
  { WAY_TYPE_ID: "78", WAY_TYPE_NAME: "ESPACE" },
  { WAY_TYPE_ID: "58", WAY_TYPE_NAME: "ESPLANADE" },
  { WAY_TYPE_ID: "75", WAY_TYPE_NAME: "ETANG" },
  { WAY_TYPE_ID: "51", WAY_TYPE_NAME: "FAUBOURG" },
  { WAY_TYPE_ID: "13", WAY_TYPE_NAME: "FERME" },
  { WAY_TYPE_ID: "79", WAY_TYPE_NAME: "FONTAINE" },
  { WAY_TYPE_ID: "103", WAY_TYPE_NAME: "FORT" },
  { WAY_TYPE_ID: "150", WAY_TYPE_NAME: "FORUM" },
  { WAY_TYPE_ID: "127", WAY_TYPE_NAME: "FOSSE" },
  { WAY_TYPE_ID: "95", WAY_TYPE_NAME: "FOYER" },
  { WAY_TYPE_ID: "86", WAY_TYPE_NAME: "GALERIE" },
  { WAY_TYPE_ID: "69", WAY_TYPE_NAME: "GARE" },
  { WAY_TYPE_ID: "143", WAY_TYPE_NAME: "GARENNE" },
  { WAY_TYPE_ID: "169", WAY_TYPE_NAME: "GRAND BOULEVARD" },
  { WAY_TYPE_ID: "70", WAY_TYPE_NAME: "GRANDE RUE" },
  { WAY_TYPE_ID: "144", WAY_TYPE_NAME: "GRILLE" },
  { WAY_TYPE_ID: "170", WAY_TYPE_NAME: "GRIMPETTE" },
  { WAY_TYPE_ID: "72", WAY_TYPE_NAME: "GROUPE" },
  { WAY_TYPE_ID: "172", WAY_TYPE_NAME: "GROUPEMENT" },
  { WAY_TYPE_ID: "135", WAY_TYPE_NAME: "HALLE" },
  { WAY_TYPE_ID: "12", WAY_TYPE_NAME: "HAMEAU" },
  { WAY_TYPE_ID: "171", WAY_TYPE_NAME: "HAUT CHEMIN" },
  { WAY_TYPE_ID: "162", WAY_TYPE_NAME: "HIPPODROME" },
  { WAY_TYPE_ID: "35", WAY_TYPE_NAME: "HLM" },
  { WAY_TYPE_ID: "89", WAY_TYPE_NAME: "ILE" },
  { WAY_TYPE_ID: "39", WAY_TYPE_NAME: "IMMEUBLE" },
  { WAY_TYPE_ID: "4", WAY_TYPE_NAME: "IMPASSE" },
  { WAY_TYPE_ID: "68", WAY_TYPE_NAME: "JARDINS" },
  { WAY_TYPE_ID: "156", WAY_TYPE_NAME: "JETEE" },
  { WAY_TYPE_ID: "113", WAY_TYPE_NAME: "LEVEE" },
  { WAY_TYPE_ID: "178", WAY_TYPE_NAME: "LOTISSEMENT" },
  { WAY_TYPE_ID: "64", WAY_TYPE_NAME: "MAIL" },
  { WAY_TYPE_ID: "57", WAY_TYPE_NAME: "MAISON FORESTIERE" },
  { WAY_TYPE_ID: "61", WAY_TYPE_NAME: "MANOIR" },
  { WAY_TYPE_ID: "120", WAY_TYPE_NAME: "MARCHE" },
  { WAY_TYPE_ID: "19", WAY_TYPE_NAME: "MAS" },
  { WAY_TYPE_ID: "167", WAY_TYPE_NAME: "METRO" },
  { WAY_TYPE_ID: "28", WAY_TYPE_NAME: "MONTEE" },
  { WAY_TYPE_ID: "17", WAY_TYPE_NAME: "MOULIN" },
  { WAY_TYPE_ID: "148", WAY_TYPE_NAME: "MUSEE" },
  { WAY_TYPE_ID: "154", WAY_TYPE_NAME: "NOUVELLE ROUTE" },
  { WAY_TYPE_ID: "138", WAY_TYPE_NAME: "PALAIS" },
  { WAY_TYPE_ID: "41", WAY_TYPE_NAME: "PARC" },
  { WAY_TYPE_ID: "115", WAY_TYPE_NAME: "PARKING" },
  { WAY_TYPE_ID: "109", WAY_TYPE_NAME: "PARVIS" },
  { WAY_TYPE_ID: "18", WAY_TYPE_NAME: "PASSAGE" },
  { WAY_TYPE_ID: "124", WAY_TYPE_NAME: "PASSE" },
  { WAY_TYPE_ID: "118", WAY_TYPE_NAME: "PASSERELLE" },
  { WAY_TYPE_ID: "159", WAY_TYPE_NAME: "PATIO" },
  { WAY_TYPE_ID: "71", WAY_TYPE_NAME: "PAVILLON" },
  { WAY_TYPE_ID: "164", WAY_TYPE_NAME: "PERIPHERIQUE" },
  { WAY_TYPE_ID: "163", WAY_TYPE_NAME: "PERISTYLE" },
  { WAY_TYPE_ID: "91", WAY_TYPE_NAME: "PETIT CHEMIN" },
  { WAY_TYPE_ID: "137", WAY_TYPE_NAME: "PETITE AVENUE" },
  { WAY_TYPE_ID: "151", WAY_TYPE_NAME: "PETITE IMPASSE" },
  { WAY_TYPE_ID: "117", WAY_TYPE_NAME: "PETITE ROUTE" },
  { WAY_TYPE_ID: "49", WAY_TYPE_NAME: "PETITE RUE" },
  { WAY_TYPE_ID: "6", WAY_TYPE_NAME: "PLACE" },
  { WAY_TYPE_ID: "129", WAY_TYPE_NAME: "PLACIS" },
  { WAY_TYPE_ID: "112", WAY_TYPE_NAME: "PLAGE" },
  { WAY_TYPE_ID: "62", WAY_TYPE_NAME: "PLAINE" },
  { WAY_TYPE_ID: "53", WAY_TYPE_NAME: "PLAN" },
  { WAY_TYPE_ID: "93", WAY_TYPE_NAME: "PLATEAU" },
  { WAY_TYPE_ID: "106", WAY_TYPE_NAME: "PN" },
  { WAY_TYPE_ID: "107", WAY_TYPE_NAME: "POINTE" },
  { WAY_TYPE_ID: "30", WAY_TYPE_NAME: "PONT" },
  { WAY_TYPE_ID: "60", WAY_TYPE_NAME: "PORT" },
  { WAY_TYPE_ID: "76", WAY_TYPE_NAME: "PORTE" },
  { WAY_TYPE_ID: "165", WAY_TYPE_NAME: "PORTIQUE" },
  { WAY_TYPE_ID: "142", WAY_TYPE_NAME: "POTERNE" },
  { WAY_TYPE_ID: "152", WAY_TYPE_NAME: "POURTOUR" },
  { WAY_TYPE_ID: "48", WAY_TYPE_NAME: "PRE" },
  { WAY_TYPE_ID: "134", WAY_TYPE_NAME: "PRESQU ILE" },
  { WAY_TYPE_ID: "45", WAY_TYPE_NAME: "PROMENADE" },
  { WAY_TYPE_ID: "26", WAY_TYPE_NAME: "QUAI" },
  { WAY_TYPE_ID: "9", WAY_TYPE_NAME: "QUARTIER" },
  { WAY_TYPE_ID: "140", WAY_TYPE_NAME: "RACCOURCI" },
  { WAY_TYPE_ID: "160", WAY_TYPE_NAME: "RAIDILLON" },
  { WAY_TYPE_ID: "84", WAY_TYPE_NAME: "RAMPE" },
  { WAY_TYPE_ID: "116", WAY_TYPE_NAME: "REMPART" },
  { WAY_TYPE_ID: "10", WAY_TYPE_NAME: "RESIDENCE" },
  { WAY_TYPE_ID: "92", WAY_TYPE_NAME: "ROCADE" },
  { WAY_TYPE_ID: "40", WAY_TYPE_NAME: "ROND POINT" },
  { WAY_TYPE_ID: "161", WAY_TYPE_NAME: "ROQUET" },
  { WAY_TYPE_ID: "158", WAY_TYPE_NAME: "ROTONDE" },
  { WAY_TYPE_ID: "5", WAY_TYPE_NAME: "ROUTE" },
  { WAY_TYPE_ID: "1", WAY_TYPE_NAME: "RUE" },
  { WAY_TYPE_ID: "14", WAY_TYPE_NAME: "RUELLE" },
  { WAY_TYPE_ID: "21", WAY_TYPE_NAME: "SENTIER" },
  { WAY_TYPE_ID: "15", WAY_TYPE_NAME: "SQUARE" },
  { WAY_TYPE_ID: "111", WAY_TYPE_NAME: "STADE" },
  { WAY_TYPE_ID: "90", WAY_TYPE_NAME: "STATION" },
  { WAY_TYPE_ID: "98", WAY_TYPE_NAME: "TERRAIN" },
  { WAY_TYPE_ID: "97", WAY_TYPE_NAME: "TERRASSE" },
  { WAY_TYPE_ID: "145", WAY_TYPE_NAME: "TERRE PLEIN" },
  { WAY_TYPE_ID: "119", WAY_TYPE_NAME: "TERTRE" },
  { WAY_TYPE_ID: "81", WAY_TYPE_NAME: "TOUR" },
  { WAY_TYPE_ID: "29", WAY_TYPE_NAME: "TRAVERSE" },
  { WAY_TYPE_ID: "56", WAY_TYPE_NAME: "VALLEE" },
  { WAY_TYPE_ID: "85", WAY_TYPE_NAME: "VCHE" },
  { WAY_TYPE_ID: "44", WAY_TYPE_NAME: "VENELLE" },
  { WAY_TYPE_ID: "133", WAY_TYPE_NAME: "VIA" },
  { WAY_TYPE_ID: "99", WAY_TYPE_NAME: "VIEILLE ROUTE" },
  { WAY_TYPE_ID: "31", WAY_TYPE_NAME: "VILLA" },
  { WAY_TYPE_ID: "20", WAY_TYPE_NAME: "VILLAGE" },
  { WAY_TYPE_ID: "37", WAY_TYPE_NAME: "VOIE" },
  { WAY_TYPE_ID: "36", WAY_TYPE_NAME: "ZA" },
  { WAY_TYPE_ID: "65", WAY_TYPE_NAME: "ZAC" },
  { WAY_TYPE_ID: "38", WAY_TYPE_NAME: "ZI" },
  { WAY_TYPE_ID: "63", WAY_TYPE_NAME: "ZONE" },
  { WAY_TYPE_ID: "176", WAY_TYPE_NAME: "ZUP" },
  { WAY_TYPE_ID: "3", WAY_TYPE_NAME: null },
  { WAY_TYPE_ID: "0", WAY_TYPE_NAME: null }
];

export const getWayTypeName = (wayTypeId: string | number | null | undefined): string => {
  if (!wayTypeId) return '';
  const wayType = WAY_TYPES.find(wt => wt.WAY_TYPE_ID === wayTypeId.toString());
  return wayType?.WAY_TYPE_NAME || '';
};

export const getWayType = (wayTypeId: string | number | null | undefined) => {
  if (!wayTypeId) return null;
  return WAY_TYPES.find(wt => wt.WAY_TYPE_ID === wayTypeId.toString()) || null;
};

export default WAY_TYPES;